SiteValidator.$inject = ['validator'];

export default function SiteValidator(validator) {
    const instance = new validator();

    return instance;
}
